import { connect, MapDispatchToProps } from 'react-redux';
import { batchEditTags } from '../../../actions/studio';
import { BatchEditTagsOperation } from '../../../types/batchActions';
import { Props } from './TagsBatchEdit';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchEditTags'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<
  DispatchProps,
  OwnProps
> = dispatch => ({
  batchEditTags: (operation: BatchEditTagsOperation, tags: string[]) =>
    dispatch(batchEditTags(operation, tags)),
});

export default connect(null, mapDispatchToProps);
